import React from "react";
import './modal.css'

const Modal = ({
    show,
    title,
    children,
    onClose,
    onSave,
    showFooter,
    saveText,
    closeText,
}) => {
    if (!show) return null;

    return (
        <>
            <div className="modal-backdrop show"></div>

            <div
                className="modal show"
                tabIndex="-1"
                role="dialog"
                style={{ display: "block" }}
            >
                <div className="modal-dialog" role="document">
                    <div className="modal-content">

                        <div className="modal-header">
                            {title && <h5 className="modal-title">{title}</h5>}
                            <button
                                type="button"
                                className="close"
                                aria-label="Close"
                                onClick={onClose}
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>


                        <div className="modal-body">{children}</div>


                        {showFooter && (
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={onClose}
                                >
                                    {closeText}
                                </button>

                                {onSave && (
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={onSave}
                                    >
                                        {saveText}
                                    </button>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default Modal;
